import React from 'react';
import PropTypes from 'prop-types';
import Grid from '../Grid';
import GridItem from '../GridItem';
import Button from '../Button';
import createStyle from 'shared-utils/src/createStyle';
import makeClassName from 'shared-utils/src/makeClassName';
import isArray from 'shared-utils/src/checkVarType/isArray';
import styles, { mainCls } from './styles';

const useStyles = createStyle(styles);

const DsButtons = (btns, classes) => {
  let buttons = null;
  const discard = btns.filter((btn) => !btn.confirm)[0];
  const confirm = btns.filter((btn) => btn.confirm)[0];
  const hasAdditional = confirm && confirm.additionalMsg;
  
  buttons = (
    <Grid
      gutters="m"
      align={hasAdditional ? 'flex-end' : ''}
      noWrap
    >
      {
        discard
          && (
            <GridItem
              {...{ behavior: 'fixed' }}
              className={!confirm ? classes[`${mainCls}__btncont--discard`] : null}
            >
              <Button
                {...discard}
                bg="w"
                className={`${classes[`${mainCls}__btn`]} ${classes[`${mainCls}__btn--discard`]}`}
              />
            </GridItem>
          )
      }
      {
        confirm
          && (
            <GridItem
              {...{ behavior: 'fixed', push: 'left' }}
              className={`${classes[`${mainCls}__btncont--confirm`]} ${confirm.fixedWidth ? classes[`${mainCls}__btncont--confirm--fw`] : ''}`}              
            >
              {hasAdditional && (
                <p className={`${classes[`${mainCls}__btncont--confirm--msg`]} pb--xs tp-w--l c-txt--secondary tp-a--c`}>{confirm.additionalMsg}</p>
              )}
              <Button
                {...confirm}
                bg="primary"
                className={`${classes[`${mainCls}__btn`]} ${classes[`${mainCls}__btn--confirm`]}`}
              />
            </GridItem>
          )
      }
    </Grid>
  );
  return buttons;
};

export default function ModalFooter({
  className,
  actions,
  footer,
  data,
  version,
  noBrd,
}) {
  const classes = useStyles();
  const clsMain = makeClassName([
    className,
    classes[mainCls],
    version > 1 ? classes[`${mainCls}--DS`] : '',
    'c-bg--w',
    version < 4 && !noBrd ? 'bt--s' : '',
  ]);
  const actsRes = typeof actions === 'function' ? actions(data) : actions;
  const hasActions = isArray(actsRes) ? !!actsRes.length : !!actsRes;
  let buttons = null;
  if (hasActions) {
    if (version > 1) {   
      // console.log(actsRes);

      buttons = DsButtons(actsRes, classes);
    } else {      
      buttons = isArray(actsRes)
      ? (
        <Grid gutters="m" noWrap>
          {actsRes.map(
            ({ grid = {}, ...btn }) => {
              return (
                <GridItem key={btn.key || btn.value} {...{ behavior: 'fixed', ...grid }}>
                  <Button {...btn} />
                </GridItem>
              );
            },
          )}
        </Grid>
      ) : actsRes;
    }
  }
  return (
    (hasActions || footer) &&
    <GridItem className={clsMain} behavior="fixed">
      { !!footer && footer }
      {buttons}
    </GridItem>
  );
};

ModalFooter.propTypes = {
  /**
   * Component class
   */
  className: PropTypes.string,

  /**
   * Footer buttons (Using props from Button)
   */
  actions: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.node,
    PropTypes.func,
  ]),

  /**
   * Custom footer content
   */
  footer: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),

  /**
   * Callback data passed from the Modal (to use in actions)
   */
  data: PropTypes.object,

  /**
   * New standard layout
   */  
   version: PropTypes.number,

  /**
   * Should have no border top
   */ 
   noBrd: PropTypes.bool,
};

ModalFooter.defaultProps = {
  className: '',
  actions: [],
  footer: '',
  data: {},
  version: 1,
  noBrd: false,
};
